if (!window.__giftWrapClickBound) {
  window.__giftWrapClickBound = true;
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.mini-cart__gift-add');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.classList.add('is-loading');
    btn.textContent = '…';

    var miniCart = document.querySelector('mini-cart');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: 1 }],
        sections: 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function(r) { return r.json(); })
      .then(function(response) {
        if (response.status && response.status === 422) {
          btn.textContent = 'Erreur';
          setTimeout(function() { btn.textContent = 'Ajouter'; btn.classList.remove('is-loading'); }, 2000);
          return;
        }
        if (miniCart && miniCart.renderContents) {
          miniCart.renderContents(response);
        } else {
          window.location.reload();
        }
      })
      .catch(function(err) {
        console.error('Gift wrap add error:', err);
        btn.textContent = 'Erreur';
        setTimeout(function() { btn.textContent = 'Ajouter'; btn.classList.remove('is-loading'); }, 2000);
      });
  }, true);

}

/* ═══ Auto-cleanup orphaned children (Bundle + Globo) ═══ */
/* When a parent is removed, its children remain as ghost items.
   This runs after every cart change and removes orphaned children. */
(function() {
  var cleaning = false;

  function cleanOrphanedChildren() {
    if (cleaning) return;
    cleaning = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        /* Collect all existing parent group IDs */
        var bundleGroups = {};
        var gpoGroups = {};

        cart.items.forEach(function(item) {
          if (!item.properties) return;
          if (item.properties['_bundle_group']) {
            bundleGroups[item.properties['_bundle_group']] = true;
          }
          if (item.properties['_gpo_product_group']) {
            gpoGroups[String(item.properties['_gpo_product_group'])] = true;
          }
        });

        /* Find orphaned children (parent no longer exists) */
        var orphanUpdates = {};
        cart.items.forEach(function(item) {
          if (!item.properties) return;
          var bp = item.properties['_bundle_parent'];
          if (bp && !bundleGroups[bp]) {
            orphanUpdates[item.key] = 0;
          }
          var gp = item.properties['_gpo_parent_product_group'];
          if (gp && !gpoGroups[String(gp)]) {
            orphanUpdates[item.key] = 0;
          }
        });

        if (Object.keys(orphanUpdates).length === 0) {
          cleaning = false;
          return;
        }

        /* Remove orphans */
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: orphanUpdates })
        })
          .then(function(r) { return r.json(); })
          .then(function(updatedCart) {
            cleaning = false;
            /* Refresh cart UI */
            var miniCart = document.querySelector('mini-cart');
            if (miniCart && miniCart.renderContents) {
              /* Re-fetch sections for proper render */
              fetch('/cart.js', { credentials: 'same-origin' })
                .then(function(r) { return r.json(); })
                .then(function() {
                  /* Force section re-render by fetching current page with sections */
                  var sectionsUrl = window.location.pathname;
                  fetch(sectionsUrl + '?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble')
                    .then(function(r) { return r.json(); })
                    .then(function(sections) {
                      if (sections['mini-cart']) {
                        var el = document.getElementById('mini-cart');
                        if (el) {
                          var tmp = new DOMParser().parseFromString(sections['mini-cart'], 'text/html');
                          var content = tmp.querySelector('.shopify-section');
                          if (content) el.innerHTML = content.innerHTML;
                        }
                      }
                      ['cart-icon-bubble', 'mobile-cart-icon-bubble'].forEach(function(id) {
                        if (sections[id]) {
                          var el = document.getElementById(id);
                          if (el) {
                            var tmp = new DOMParser().parseFromString(sections[id], 'text/html');
                            var content = tmp.querySelector('.shopify-section');
                            if (content) el.innerHTML = content.innerHTML;
                          }
                        }
                      });
                    });
                });
            }
            /* On cart page, reload to reflect changes */
            if (window.location.pathname.indexOf('/cart') !== -1) {
              window.location.reload();
            }
          })
          .catch(function() { cleaning = false; });
      })
      .catch(function() { cleaning = false; });
  }

  /* Hook: intercept fetch to cart/change and cart/update endpoints */
  var origFetch = window.fetch;
  window.fetch = function() {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var isCartMod = url.indexOf('/cart/change') !== -1 || (url.indexOf('/cart/update') !== -1 && !cleaning);

    var result = origFetch.apply(this, arguments);

    if (isCartMod) {
      result.then(function() {
        setTimeout(cleanOrphanedChildren, 300);
      });
    }

    return result;
  };

  /* Also run on page load to catch any leftover orphans */
  setTimeout(cleanOrphanedChildren, 1000);
})();

// Lightbox zoom — fonction globale appelée via onclick="window.__giftZoom(this)"
window.__giftZoom = function(btn) {
  var src = btn.getAttribute('data-full-src');
  var alt = btn.getAttribute('data-alt') || '';
  if (!src) return;
  var lightbox = document.createElement('div');
  lightbox.className = 'gift-lightbox';
  lightbox.innerHTML = '<img src="' + src + '" alt="' + alt.replace(/"/g, '&quot;') + '">';
  document.body.appendChild(lightbox);

  lightbox.addEventListener('click', function(ev) {
    ev.stopPropagation();
    if (ev.target === lightbox) {
      lightbox.remove();
    }
  });

  document.addEventListener('keydown', function handler(ev) {
    if (ev.key === 'Escape') {
      lightbox.remove();
      document.removeEventListener('keydown', handler);
    }
  });
};

/* ═══ Gift Wrap Variant Dropdown Selector ═══ */
document.addEventListener('change', function(e) {
  var select = e.target.closest('[data-gw-select]');
  if (!select) return;

  var item = select.closest('.mini-cart__gift-item');
  if (!item) return;

  /* Collect all selected option values */
  var selectedOptions = [];
  item.querySelectorAll('[data-gw-select]').forEach(function(sel) {
    selectedOptions.push(sel.value);
  });

  /* Find matching variant from JSON */
  var jsonScript = item.querySelector('[data-gw-variant-json]');
  if (!jsonScript) return;

  var variants;
  try { variants = JSON.parse(jsonScript.textContent); } catch (err) { return; }

  var matched = null;
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    var opts = [v.option1, v.option2, v.option3];
    var isMatch = true;
    for (var j = 0; j < selectedOptions.length; j++) {
      if (selectedOptions[j] && opts[j] !== selectedOptions[j]) {
        isMatch = false;
        break;
      }
    }
    if (isMatch) { matched = v; break; }
  }

  if (!matched) return;

  /* Update button variant ID + dispo */
  var addBtn = item.querySelector('.mini-cart__gift-add');
  if (addBtn) {
    addBtn.setAttribute('data-variant-id', matched.id);
    if (matched.available) {
      addBtn.disabled = false;
      addBtn.textContent = 'Ajouter';
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Épuisé';
    }
  }

  /* Update price */
  var priceEl = item.querySelector('[data-gw-price]');
  if (priceEl) {
    var formatted = window.theme && window.theme.moneyFormat
      ? window.theme.moneyFormat.replace('{{amount}}', (matched.price / 100).toFixed(2).replace('.', ','))
      : (matched.price / 100).toFixed(2).replace('.', ',') + '€';
    priceEl.innerHTML = formatted;
  }

  /* Update image if variant has a featured image */
  if (matched.featured_image && matched.featured_image.src) {
    var imgEl = item.querySelector('.mini-cart__gift-image img');
    if (imgEl) {
      imgEl.src = matched.featured_image.src.replace(/(\.\w+)\?/, '_160x$&').replace(/\?.*/, '') + '?width=160';
    }
  }
}, true);

/* ═══ Cart Quantity Selector — Bundle-aware +/- ═══ */
(function(){
  var qtyBusy = false;

  function refreshCart(){
    /* Always fetch sections via /cart URL to ensure correct rendering */
    fetch('/cart?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble')
      .then(function(r){ return r.json(); })
      .then(function(sections){
        if(sections['mini-cart']){
          var el = document.getElementById('mini-cart');
          if(el){
            var tmp = new DOMParser().parseFromString(sections['mini-cart'], 'text/html');
            var content = tmp.querySelector('.shopify-section');
            if(content) el.innerHTML = content.innerHTML;
          }
        }
        ['cart-icon-bubble','mobile-cart-icon-bubble'].forEach(function(id){
          if(sections[id]){
            var el = document.getElementById(id);
            if(el){
              var tmp = new DOMParser().parseFromString(sections[id], 'text/html');
              var content = tmp.querySelector('.shopify-section');
              if(content) el.innerHTML = content.innerHTML;
            }
          }
        });
      });
    /* On cart page, reload to refresh the main content */
    if(window.location.pathname.indexOf('/cart') !== -1){
      window.location.reload();
    }
  }

  /* Collect all items belonging to a bundle group (parent + bundle children + GPO children) */
  function collectGroupItems(cart, bundleGroup){
    var items = [];
    var parentGpoGroup = null;

    /* First pass: find parent's _gpo_product_group if any */
    cart.items.forEach(function(ci){
      if(ci.properties && ci.properties['_bundle_group'] === bundleGroup && ci.properties['_gpo_product_group']){
        parentGpoGroup = String(ci.properties['_gpo_product_group']);
      }
    });

    /* Second pass: collect all items */
    var seen = {};
    cart.items.forEach(function(ci){
      if(!ci.properties || seen[ci.key]) return;

      /* Parent */
      if(ci.properties['_bundle_group'] === bundleGroup){
        seen[ci.key] = true;
        items.push(ci);
      }
      /* Bundle children */
      if(ci.properties['_bundle_parent'] === bundleGroup){
        seen[ci.key] = true;
        items.push(ci);
      }
      /* GPO children (matched by parent's _gpo_product_group) */
      if(parentGpoGroup && ci.properties['_gpo_parent_product_group']){
        if(String(ci.properties['_gpo_parent_product_group']) === parentGpoGroup){
          seen[ci.key] = true;
          items.push(ci);
        }
      }
    });
    return items;
  }

  /* PLUS: duplicate entire group (bundle or GPO) or increment simple product */
  function handlePlus(selector){
    if(qtyBusy) return;
    qtyBusy = true;
    var bundleGroup = selector.getAttribute('data-bundle-group');
    var gpoGroup = selector.getAttribute('data-gpo-group');
    var itemKey = selector.getAttribute('data-item-key');
    var hasGroup = bundleGroup || gpoGroup;

    if(hasGroup){
      fetch('/cart.js', {credentials:'same-origin'})
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var addItems = [];
          var parentItem = null;

          if(bundleGroup){
            /* Bundle group: collect via _bundle_group */
            var groupItems = collectGroupItems(cart, bundleGroup);
            var newGroupId = Date.now().toString(36) + Math.random().toString(36).substr(2, 5);

            /* Find parent for label */
            groupItems.forEach(function(ci){
              if(ci.properties && ci.properties['_bundle_group'] === bundleGroup) parentItem = ci;
            });

            /* Count existing groups for numbering */
            var parentTitle = parentItem ? (parentItem.product_title || parentItem.title || '') : '';
            var sameCount = 0;
            var seenG = {};
            cart.items.forEach(function(ci){
              if(ci.properties && ci.properties['_bundle_group'] && (ci.product_title === parentTitle)){
                if(!seenG[ci.properties['_bundle_group']]){ seenG[ci.properties['_bundle_group']] = true; sameCount++; }
              }
            });
            var newLabel = parentTitle + ' (' + (sameCount + 1) + ')';

            groupItems.forEach(function(ci){
              var props = {};
              for(var k in ci.properties){
                if(k === '_bundle_group') props[k] = newGroupId;
                else if(k === '_bundle_parent') props[k] = newGroupId;
                else if(k === 'Produit parent') props[k] = newLabel;
                else props[k] = ci.properties[k];
              }
              if(ci.properties['_bundle_parent'] && !props['Produit parent']) props['Produit parent'] = newLabel;
              addItems.push({ id: ci.variant_id, quantity: ci.quantity, properties: props });
            });

          } else if(gpoGroup){
            /* GPO-only group: collect parent + GPO children by _gpo_product_group */
            var gpoGroupStr = String(gpoGroup);

            /* Find parent */
            cart.items.forEach(function(ci){
              if(ci.properties && String(ci.properties['_gpo_product_group']) === gpoGroupStr) parentItem = ci;
            });

            /* Duplicate parent with all its properties */
            if(parentItem){
              var pprops = {};
              for(var k in parentItem.properties) pprops[k] = parentItem.properties[k];
              addItems.push({ id: parentItem.variant_id, quantity: parentItem.quantity, properties: pprops });
            }

            /* Duplicate GPO children */
            cart.items.forEach(function(ci){
              if(ci.properties && String(ci.properties['_gpo_parent_product_group']) === gpoGroupStr){
                var cprops = {};
                for(var k in ci.properties) cprops[k] = ci.properties[k];
                addItems.push({ id: ci.variant_id, quantity: ci.quantity, properties: cprops });
              }
            });
          }

          if(addItems.length === 0){ qtyBusy = false; return; }

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: addItems })
          });
        })
        .then(function(){ qtyBusy = false; refreshCart(); })
        .catch(function(){ qtyBusy = false; });
    } else {
      /* Simple product: increment quantity */
      var currentQty = parseInt(selector.getAttribute('data-quantity')) || 1;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: currentQty + 1 })
      })
        .then(function(){ qtyBusy = false; refreshCart(); })
        .catch(function(){ qtyBusy = false; });
    }
  }

  /* MINUS: remove entire group (bundle or GPO) or decrement simple product */
  function handleMinus(selector){
    if(qtyBusy) return;
    qtyBusy = true;
    var bundleGroup = selector.getAttribute('data-bundle-group');
    var gpoGroup = selector.getAttribute('data-gpo-group');
    var itemKey = selector.getAttribute('data-item-key');
    var currentQty = parseInt(selector.getAttribute('data-quantity')) || 1;
    var hasGroup = bundleGroup || gpoGroup;

    if(hasGroup){
      fetch('/cart.js', {credentials:'same-origin'})
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var updates = {};

          if(bundleGroup){
            var groupItems = collectGroupItems(cart, bundleGroup);
            groupItems.forEach(function(ci){ updates[ci.key] = 0; });
          } else if(gpoGroup){
            var gpoGroupStr = String(gpoGroup);
            cart.items.forEach(function(ci){
              if(!ci.properties) return;
              if(String(ci.properties['_gpo_product_group']) === gpoGroupStr) updates[ci.key] = 0;
              if(String(ci.properties['_gpo_parent_product_group']) === gpoGroupStr) updates[ci.key] = 0;
            });
          }

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        })
        .then(function(){ qtyBusy = false; refreshCart(); })
        .catch(function(){ qtyBusy = false; });
    } else {
      /* Simple product: decrement or remove */
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: currentQty - 1 })
      })
        .then(function(){ qtyBusy = false; refreshCart(); })
        .catch(function(){ qtyBusy = false; });
    }
  }

  /* Event delegation — works on drawer (innerHTML survives via document listener) */
  document.addEventListener('click', function(e){
    var plusBtn = e.target.closest('[data-qty-plus]');
    if(plusBtn){
      var sel = plusBtn.closest('[data-qty-selector]');
      if(sel) handlePlus(sel);
      return;
    }
    var minusBtn = e.target.closest('[data-qty-minus]');
    if(minusBtn){
      var sel = minusBtn.closest('[data-qty-selector]');
      if(sel) handleMinus(sel);
      return;
    }
  }, true);
})();
